<template>
    <div class="home-container">
        <!-- 导航 -->
        <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
        <!-- 头部背景 -->
        <div class="top_bg">
            <div class="container_box">
                <div style="font-size: 50px;">让天下没有难做的生意</div>
                <div style="font-size: 20px;margin-top: 20px;font-size: 20px;">坚持为小企业服务,因为小企业是中国梦想最多的地方</div>
            </div>
        </div>
        <div class="first">
            <div class="first_container">
                <div class="first_box">
                    <div class="left_img">
                        <img src="../../static/img/school/img1.png" alt="" width="100%;height:100%">
                    </div>
                    <div class="right_img">
                        <img src="../../static/img/school/logo.png" alt="" style="width: 100%;height: 100%;">
                    </div>
                    <div class="bottom_box">
                        <div class="middle_img">
                            <img src="../../static/img/school/VIP.png" alt=""></div>
                        <div class="begin">
                            <img src="../../static/img/school/begin.png" alt="" style="width: 141px;height: 23px;">
                            <div class="begin_text">对标阿里合作共赢</div>
                        </div>
                        <div class="middle_text">学习顾问分享阿里发展之路，引导学员带着疑问对标学习阿里，帮助大家梳理阿里文化与学习点</div>
                        <div class="begin">
                            <img src="../../static/img/school/begin.png" alt="" style="width: 141px;height: 23px;">
                            <div class="begin_text">向阿里学习什么</div>
                        </div>
                        <div class="middle_text">1.企业文化 2.人力资源 3.战略循环 4.业务循环 5.销售铁军 6.干部培养 以上六个维度全面解读阿里巴巴成功之道</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="teach_container">
            <div style="display: flex;align-items: center;">
                <div>
                    <div class="title">MEIFUZX</div>
                    <div class="title2">讲师介绍</div>
                </div>
                <div class="float_line"></div>
            </div>
            <div class="teach_list">
                <div class="list_box">
                    <div class="down_box"></div>
                    <div class="up_box">
                        <div class="up_img">
                            <img src="../../static/img/school/img9.png" alt="" style="width: 100%;height: 100%;">
                        </div>
                        <div class="over_box">
                            <div style="width: 4px;height: 50px;margin-top: 10px;margin-left: 20px;background: orange;"></div>
                            <div style="text-align: center;margin-top: 50px;font-size: 25px;color: orange;">找美商学院</div>
                        </div>
                        <div  class="person_box">
                            <!-- <div style="width: 62px;height: 62px;">
                                <img src="../../static/img/company/img.jpg" alt="" style="width: 100%;height: 100%;">
                            </div> -->
                            <div  class="person_name">梁老师</div>
                        </div>  
                    </div>
                </div>
                <div class="list_box">
                    <div class="down_box"></div>
                    <div class="up_box">
                        <div class="up_img">
                            <img src="../../static/img/school/img2.png" alt="" style="width: 100%;height: 100%;">
                        </div>
                        <div class="over_box">
                            找美商学院
                        </div>
                        <div class="person_box">
                            <!-- <div style="width: 62px;height: 62px;">
                                <img src="../../static/img/company/img.jpg" alt="" style="width: 100%;height: 100%;">
                            </div> -->
                            <div  class="person_name">周老师</div>
                        </div>  
                    </div>
                </div>
                <div class="list_box">
                    <div class="down_box"></div>
                    <div class="up_box">
                        <div class="up_img">
                            <img src="../../static/img/school/img3.png" alt="" style="width: 100%;height: 100%;">
                        </div>
                        <div class="over_box">
                            找美商学院
                        </div>
                        <div class="person_box">
                            <!-- <div style="width: 62px;height: 62px;">
                                <img src="../../static/img/company/img.jpg" alt="" style="width: 100%;height: 100%;">
                            </div> -->
                            <div class="person_name">谢老师</div>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <div class="learn">
          
            <div class="learn_container">
                <div class="learn_left_box">
                   <div style="margin-left: 49px;margin-top: 46px;">
                    <div class="left_title">Why choose Alibaba?</div>
                    <div class="black_line"></div>
                    <div class="left_text">为什么选择阿里巴巴？</div>
                    <div style="margin-top: 41px;margin-left: 3px;">
                        <div class="orange_box">
                            <div class="orange_line"></div>
                            <div style="margin-left: 10px;">
                                <div class="p1">阿里巴巴全球最大-裂变发展</div>
                                <div class="p2">阿里巴巴从18人到10万人，从50万到4000亿美元，从中国第一家盈利网站到全球最大电子商务网站，阿里用18年缔造了世界奇迹。</div>
                            </div>
                        </div>
                        <div class="orange_box">
                            <div class="orange_line"></div>
                            <div style="margin-left: 10px;">
                                <div class="p1">阿里铁军精神-管理创新</div>
                                <div class="p2">阿里快速发展靠的就是铁军文化与独特的管理三板斧，三板斧就是阿里巴巴自从创业初期就一直坚持的管理原则和方法，并且到目前为止一直坚持的策略</div>
                            </div>
                        </div>
                        <div class="orange_box">
                            <div class="orange_line"></div>
                            <div style="margin-left: 10px;">
                                <div class="p1">阿里巴巴-销售奇迹，营销创新</div>
                                <div class="p2">2017年11月11日，阿里旗下淘宝网、天猫一手缔造“双十一购物狂欢节”创造出惊人的1682亿销售神话，再一次创造了中国奇迹，也创造了世界营销史上的奇迹。</div>
                            </div>
                        </div>
                    </div>
                   </div>
                </div>
                <div class="learn_middle_box">
                    <div class="learn_middle_box1">
                        <div class="learn_middle_img1">
                            <img src="../../static/img/school/img4.png" alt="" style="width: 100%;height: 100%;">
                        </div>
                    </div>
                    <div class="learn_middle_box2" style="margin-top: 15px;">
                        <div class="learn_middle_img2">
                            <img src="../../static/img/school/img5.png" alt="" style="width: 100%;height: 100%;">
                        </div>
                    </div>
                </div>
                <div class="learn_right_box">
                    <div class="learn_middle_box2" >
                        <div class="learn_middle_img2">
                            <img src="../../static/img/school/img6.png" alt="" style="width: 100%;height: 100%;">
                        </div>
                    </div>
                    <div class="learn_middle_box1" style="margin-top: 15px;">
                        <div class="learn_middle_img1">
                            <img src="../../static/img/school/img7.png" alt="" style="width: 100%;height: 100%;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 尾部 -->
        <RMBottomDiv></RMBottomDiv>
      
     
    </div>
    
   

        
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue';
    import { mapGetters } from "vuex";
    import { mapMutations } from "vuex";
    import * as types from "../store/mutation-types";
    export default {
        components: {RMTopDiv,RMBottomDiv},
        data() {
            return {
                scroll: '',
                scroll100: true,
                scroll700: false
            };
        },
        watch: {
            scroll: function () {
                this.loadSroll();
            }
        },
        methods: {
            //首页
            goToHome() {
                this.$router.push('/')
            },
            //产品中心-店务系统介绍
            goToDw() {
                this.$router.push('./home')
            },
            //产品中心-供应链
            goToSupply() {
                this.$router.push('./supplyChain')
            },
            //产品中心-营销工具
            goToMark() {
                this.$router.push('./marketingTools')
            },
            //关于我们-公司简介
            goToUS() {
                this.$router.push('./company')
            },
            //关于我们-合作渠道
            goToChannel() {
                this.$router.push('./channels')
            },
            //关于我们-招聘
            goToContact() {
                this.$router.push('./contact')
            },
            //关于我们-企业文化
            goToCulture() {
                this.$router.push('./culture')
            },
            //找美商学院-商学院文化
            goToCollege() {
                this.$router.push("./school");
            },
            //找美商学院-走进阿里
            goToAli() {
                this.$router.push('./Ali')
            },
            //找美商学院-行程安排
            gotoTravell() {
                this.$router.push('./Travell')
            },
            //找美商学院-讲师简介
            goToTeach() { },
            //找美商学院-相关案例
            goToCase() { },
            apply() {

            },
            dataScroll(event) {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
            },
            loadSroll: function () {
                if (this.scroll <= 100) {
                    this.scroll100 = true
                } else {
                    this.scroll100 = false
                }
                if (this.scroll > 100) {
                    this.scroll700 = true
                } else {
                    this.scroll700 = false
                }
            },
        },
        created() {

        },

        computed: {
            ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])

        },
        mounted() {
            //获取高度
            window.addEventListener("scroll", this.dataScroll, true);
        }
    };
</script>

<style scoped lang="scss">
    @import "../assets/css/them.scss";
    @import "../assets/css/mains.css";

    .home-container {
        background-color: #fff;
        width: 100%;
        height: 100%;
        position: fixed;
        overflow-y: scroll;
    }

    .top_bg {
        background-image: url('../../static/img/channels/bigname2.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 824px;
        position: relative;
        top: 0;
        left: 0;
    }

    .container_box {
        z-index: 1;
        position: absolute;
        top: 30%;
        left: 0;
        color: #fff;
        text-align: center;
        min-width: 769px;
        width: 100%;
    }

    .first {
        width: 100%;
        height: 601px;
        position: absolute;
        top: 668px;
    }

    .first_container {
        width: 1200px;
        height: 601px;
        margin: 0 auto;
        background: white;
        border: 0px solid rgba(151, 151, 151, 1);
        ;
    }

    .first_box {
        padding-top: 32px;
        padding-left: 27px;
        padding-bottom: 27px;
       
        display: flex;
        position: relative;
    }

    .left_img {
        width: 540px;
        height: 542px;
    }

    .right_img {
        width: 363px;
        height: 49px;
        margin-left: 40px;
        margin-top: 20px;
    }

    .bottom_box {
        width: 814px;
        height: 426px;
        position: absolute;
        right: 0;
        bottom: 27px;
        background: white;
        box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.1);
    }
    .middle_img{
        width: 65px;
        height: 33px;
        background: yellow;
        margin-left: 91px;
        margin-top: 74px;
    }
    .begin{
        width: 300px;
        height: 23px;
        margin-top: 36px;
        margin-left: 91px;
        position: relative;
    }
    .begin_text{
        font-size: 20px;
        color: #ED7829;
        position: absolute;
        top: -9px;left: 35px;
    }
    .middle_text{
        width: 663px;
        font-size: 16px;
        line-height: 26px;
        color: #565656;
        margin-left: 91px;
        margin-top: 15px;
        margin-right: 90px;
    }
    .teach_container{
        width: 1200px;
        margin: 0 auto;
        /* background: green; */
        padding-top: 450px;
        margin-top: 57px;
    }
    .title{
        font-size: 36px;
        color: #343434;
    }
    .title2{
        font-size: 26px;
        color: #343434;
        margin-top: 11px;
    }
    .float_line{
        background: #D8E1E0;
        width:694px;
        height:2px;
    }
    .teach_list{
        display: flex;
        height: 426px;
        margin-top: 27px;
        display: flex;
        justify-content: space-between;
        color: #fff;
    }
    .list_box{
        width: 364px;
        height: 426px;
        position: relative;
    }
   
    .down_box{
        position: relative;
        width:333px;
        height:333px;
        background:rgba(255,255,255,1);
        border:3px solid rgba(238,120,42,1);
    }
    .up_box{
        width:334px;
        height:396px;
        background: #333;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 2;
        overflow: hidden;
    }
    .up_img{
        width: 333px;
        height: 334px;
        overflow: hidden;
    }
    .over_box{
        width: 333px;
        background:rgba(0, 0, 0, 0.4);
        height: 334px;
        position: absolute;
        top: 334px;
        opacity: 0;
    }
    .person_box{
        line-height: 62px;
        display: flex;
        justify-content: center;
    }
    .person_name{
        /* margin-left: 50px; */
        z-index: 10;
    }
    .list_box:hover .over_box{
        margin-top: -334px;
        opacity: 1;
        transition: all 0.5s;
    }
    .list_box:hover .down_box{
        background:rgba(238,120,42,1) ;
    }
    .list_box:hover .up_box{
        background:rgba(238,120,42,1) ;
    }
    .list_box:hover .up_img img{
        transform: scale(1.1);
        transition: all 0.5s;
    }
    .learn{
        width: 1200px;
        margin: 0 auto;
        margin-top: 84px;
    }
    .learn_container{
        display: flex;
        height: 479px;
        margin-top: 43px;
        margin-bottom: 58px;
    }
    .learn_left_box{
        width:555px;
        height:479px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 1px rgba(237,120,41,0.25);
    }
    .left_title{
        font-size:30px;
        font-weight: 500;
        color: #292A2B;
    
    }
    .black_line{
        width: 28px;
        height: 1px;
        background: #3F3F3F;
        margin-top: 9px;
    }
    .left_text{
        margin-top: 10px;
        font-size: 20px;
        color: #292A2B;
        font-weight: 500;
    }
    .orange_box{
        display: flex;
        margin-top: 30px;
        margin-bottom: 20px;
    }
    .orange_line{
        width: 18px;
        height: 1px;
        background: #ED7829;
        margin-top: 11px;
    }
    .p1{
        font-size: 16px;
        color: #ED7829;     
    }
    .p2{
        font-size: 12px;
        color: #878787;
        margin-top: 6px;
        width: 440px;
    }
    .learn_middle_box{
        width:309px ;
        height: 479px;
        margin-left: 15px;
        background: white;
    }
    .learn_middle_box1{
        width: 309px;
        height: 155px;
        box-shadow:0px 2px 10px 1px rgba(235,109,16,0.25);
    }
    .learn_middle_img1{
        width: 293px;
        height: 139px;
        padding: 8px;
    }
    .learn_middle_box2{
        width: 309px;
        height: 309px;
        box-shadow:0px 2px 10px 1px rgba(235,113,26,0.24);
    }
    .learn_middle_img2{
        width: 293px;
        height: 293px;
        padding: 7px 8px 9px 8px;
    }
    .learn_right_box{
        width: 308px;
        height: 479px;
        margin-left: 14px;
        background: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/page/Ali.vue